import Message from '@/_shared/entities/message.entity';

const SESSION_MESSAGES_STORAGE_KEY = 'session-messages';

class SessionMessageService {
  private hasSuccessfulMessage = false;

  private hasErrorMessage = false;

  private messages: Message[] = [];

  public registerSuccessfulMessage(messageContent: string): void {
    if (this.hasSuccessfulMessage) {
      return;
    }

    this.registerMessage('success', messageContent);
    this.hasSuccessfulMessage = true;
  }

  public registerErrorMessage(messageContent: string): void {
    if (this.hasErrorMessage) {
      return;
    }

    this.registerMessage('error', messageContent);
    this.hasErrorMessage = true;
  }

  public registerMessage(type: string, content: string): void {
    const message = new Message(type, content);
    this.messages.push(message);
  }

  public getMessages(): Message[] {
    return this.messages;
  }

  public storeMessages(): void {
    sessionStorage.setItem(SESSION_MESSAGES_STORAGE_KEY, JSON.stringify(this.messages));
    this.clear();
  }

  public clear(): void {
    this.hasSuccessfulMessage = false;
    this.hasErrorMessage = false;
    this.messages = [];
  }

  public retrieveMessages(): Message[] {
    const storedMessages = sessionStorage.getItem(SESSION_MESSAGES_STORAGE_KEY);
    sessionStorage.removeItem(SESSION_MESSAGES_STORAGE_KEY);
    return JSON.parse(storedMessages ?? '[]');
  }
}

export default new SessionMessageService();
